import { styled } from "styled-components";

export const ProductPrice = styled.div`
  font-size: 18px;

  color: #383838;
`;
